/** Niveles curriculares Chile (básica y media) — orden de visualización. */
export const NIVEL_ORDEN = [
  '1_basico',
  '2_basico',
  '3_basico',
  '4_basico',
  '5_basico',
  '6_basico',
  '7_basico',
  '8_basico',
  '1_medio',
  '2_medio',
  '3_medio',
  '4_medio',
];

export const NIVEL_LABEL = {
  '1_basico': '1° básico',
  '2_basico': '2° básico',
  '3_basico': '3° básico',
  '4_basico': '4° básico',
  '5_basico': '5° básico',
  '6_basico': '6° básico',
  '7_basico': '7° básico',
  '8_basico': '8° básico',
  '1_medio': '1° medio',
  '2_medio': '2° medio',
  '3_medio': '3° medio',
  '4_medio': '4° medio',
};

export function labelNivel(codigo) {
  if (!codigo) return '—';
  return NIVEL_LABEL[codigo] || String(codigo).replace(/_/g, ' ');
}

export function ordenNivel(codigo) {
  const i = NIVEL_ORDEN.indexOf(codigo);
  return i >= 0 ? i : 999;
}

export const NIVEL_OPTS = NIVEL_ORDEN.map((value) => ({
  value,
  label: NIVEL_LABEL[value],
}));

export function compararCursos(a, b) {
  const oa = ordenNivel(a?.nivel_simce);
  const ob = ordenNivel(b?.nivel_simce);
  if (oa !== ob) return oa - ob;
  return String(a?.letra || '').localeCompare(String(b?.letra || ''), 'es');
}

export function labelCurso(c, { conInterno = true } = {}) {
  if (!c) return '—';
  const nivel = labelNivel(c.nivel_simce);
  const base = `${nivel} ${c.letra || ''}`.trim();
  if (conInterno && c.nombre_interno) return `${base} · ${c.nombre_interno}`;
  return base || '—';
}

/** Alias legacy (sync/capítulos) → código canónico SIMCE. */
const NIVEL_ALIAS = {
  '4B': '4_basico',
  '4b': '4_basico',
  '4°': '4_basico',
  '4º': '4_basico',
  '8B': '8_basico',
  '8b': '8_basico',
  '8°': '8_basico',
  '8º': '8_basico',
  '2M': '2_medio',
  '2m': '2_medio',
  '1B': '1_basico',
  '2B': '2_basico',
  '3B': '3_basico',
  '5B': '5_basico',
  '6B': '6_basico',
  '7B': '7_basico',
  '1M': '1_medio',
  '3M': '3_medio',
  '4M': '4_medio',
};

export function normalizarCodigoNivel(codigo) {
  if (!codigo) return '';
  const raw = String(codigo).trim();
  if (NIVEL_ORDEN.includes(raw)) return raw;
  if (NIVEL_ALIAS[raw]) return NIVEL_ALIAS[raw];
  const lower = raw.toLowerCase();
  if (NIVEL_ALIAS[lower]) return NIVEL_ALIAS[lower];
  return raw;
}
